'use strict';

const EXPORT_UNPAID_DELIVERIES_EVENT = 'EXPORT_UNPAID_DELIVERIES';
window.EXPORT_UNPAID_DELIVERIES_EVENT = EXPORT_UNPAID_DELIVERIES_EVENT;

const {saveAs} = require('file-saver')

module.exports = (app) => app.controller('unpaidDeliveryController', /* @ngInject */ function ($scope, deliveryReceiptService) {

    $scope.init = init;
    $scope.loading = false;
    $scope.error = false;

    function init() {
        window.addEventListener(EXPORT_UNPAID_DELIVERIES_EVENT, exportUnpaidDeliveriesEventHandler);
    }

    /**
     * Handles the custom Event to export unpaied deliveries
     * @param event {CustomEvent}
     */
    function exportUnpaidDeliveriesEventHandler(event) {
        if(!$scope.loading) {
            $scope.loading = true;
            $scope.$apply();
            deliveryReceiptService.exportUnpaidDeliveries(event.detail).then((response) => {
                saveAs(response.data, response.filename);
                $scope.loading = false;
                $scope.error = false;
                $scope.$apply();
                window.openContent('my_adm/accounting/receipt_list.htm');
            }, () => {
                $scope.loading = false;
                $scope.$apply();
                $scope.error = true;
            });
        }
    }

});
